import script from "./addurl.vue?vue&type=script&setup=true&lang=js"
export * from "./addurl.vue?vue&type=script&setup=true&lang=js"

import "./addurl.vue?vue&type=style&index=0&id=38f3488c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f3488c"]])

export default __exports__